import { ShieldCheck, Lock, Globe2, FileCheck2, EyeOff, BadgeCheck, KeyRound } from "lucide-react";

const items = [
  { Icon: ShieldCheck, label: "GDPR compliant", tone: "mkt-gradient-hero" },
  { Icon: BadgeCheck, label: "SOC 2 (in progress)", tone: "mkt-gradient-purple" },
  { Icon: EyeOff, label: "100% anonymous by design", tone: "mkt-gradient-teal" },
  { Icon: Globe2, label: "EU data residency", tone: "mkt-gradient-sunset" },
  { Icon: FileCheck2, label: "PII auto-strip pre-database", tone: "mkt-gradient-hero" },
  { Icon: KeyRound, label: "ISO 27001 aligned", tone: "mkt-gradient-purple" },
  { Icon: Lock, label: "End-to-end encrypted", tone: "mkt-gradient-teal" },
];

export const SecurityBand = () => {
  return (
    <section className="container mx-auto px-3 lg:px-8 py-16 lg:py-24">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(var(--mkt-primary))] mb-3">
          Security & compliance
        </div>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          Built For HR. Trusted By Legal.
        </h2>
        <p className="mt-4 text-muted-foreground">
          Anonymity isn't a feature here — it's the architecture.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map(({ Icon, label, tone }) => (
          <div
            key={label}
            className="group relative rounded-3xl bg-card border border-border mkt-shadow-card p-5 lg:p-6 flex items-center gap-4 transition hover:-translate-y-0.5"
          >
            <div className={`relative h-11 w-11 shrink-0 rounded-2xl ${tone} mkt-grain overflow-hidden inline-flex items-center justify-center text-white`}>
              <Icon className="h-5 w-5 relative" />
            </div>
            <div className="text-sm font-semibold text-foreground leading-snug">
              {label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
